import React from 'react'

function Hireinginfo() {
  return (
    <div>
    <h4 className="mt-4">Hiring information</h4>
                            <div className="talent_profile_detail">                                
                                <div className="add_job_des_box">
                                    <h6>$6,850.00</h6>
                                    <span>Talent bill rate for a Part-Time (20h) (in USD)</span>
                                </div>
                            </div>
    </div>
  )
}

export default Hireinginfo